import React, { useState, useEffect } from "react";

import { v4 as uuidv4 } from 'uuid';
import { DisconnectPubSub, GetPubSubToken } from "src/utils/GetPubSub";
import { SoketContext } from "./Context_api";
import { WebPubSubClient } from "@azure/web-pubsub-client";
interface messageBody {
    color?: string;
    width?: number;
}
export function Socket_Provider(props: any) {
    let value = "socket_messsage"
    const [broadcast, setBroadcast] = useState(null);
    const [uuid, setUuid] = useState(uuidv4());
    const [is_active, setActive] = useState(false);
    let Broadcast: any = new BroadcastChannel(value);
    let client: any

    useEffect(() => {

        Broadcast.addEventListener("message", (event: any) => {
            setBroadcast(event.data)
        })

        setTimeout(() => {
            connect();
        }, 3000);



    }, []);

    const connect = async () => {
        let org: any = localStorage.getItem('SETTINGS.salesOrg');
        let out = org.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, '')
        let res = await GetPubSubToken(out);
        let { userEmail, url } = res;
        if (localStorage.getItem('connectionId')) {
            await DisconnectPubSub(out)
        }
        client = new WebPubSubClient({
            getClientAccessUrl: async () => url,
        });

        await client.start();


        client.on("connected", (e: any) => {
            localStorage.setItem('connectionId', e.connectionId)
            console.log(`Socket  connected${out}`);
        });
        await client.joinGroup(out.toString());


        client.on("group-message", (e: any) => {
            let messageBody: any = e.message.data;
            if (messageBody?.event == 'is_maintenance') {
                let b_params: any = messageBody.message.split(';');

                if (b_params[0] === out) {
                    localStorage.clear();
                    window.location.href = '/'
                }
            }
            Broadcast.postMessage(messageBody);
            setBroadcast(messageBody)
        })
    }


    const postmessage = (obj: any) => {
        Broadcast.postMessage({ message: obj });
    }

    return (
        <SoketContext.Provider value={{ broadcast, postmessage, uuid, is_active, setActive }}>
            {props.children}
        </SoketContext.Provider>
    );
}